import { useEmployeesByIds } from "@/queries/employees/use-employees.query.ts";
import { ApiCustomField, ApiFieldValueTypes } from "@/types/custom-field.types.ts";

const isEmployeeReference = ({ field }: ApiCustomField) =>
  field.field_type === ApiFieldValueTypes.employee_reference;

export default function useCustomFieldsWithEmployees(customFields: ApiCustomField[]) {
  const employeeIds = customFields.flatMap((customField) =>
    isEmployeeReference(customField) ? (customField.value?.value_int_array ?? []) : []
  );
  const { data: employees } = useEmployeesByIds(employeeIds);

  return customFields.map((customField): ApiCustomField =>
    isEmployeeReference(customField) && customField.value
      ? {
          ...customField,
          value: {
            ...customField.value,
            value_employees: (customField.value.value_int_array ?? [])
              .map((id) => employees?.find((employee) => employee.id === id))
              .filter((employee) => employee !== undefined),
          },
        }
      : customField
  );
}
